// extracted by mini-css-extract-plugin
export default {"footnotes":"vZB3bw7"};